import { render } from "./OrderStatusesIndexPage.vue?vue&type=template&id=3e3e4a3e"
import script from "./OrderStatusesIndexPage.vue?vue&type=script&lang=js"
export * from "./OrderStatusesIndexPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__